import React from 'react';
import {connect} from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

class PrivateRoute extends React.Component {
   render(){
       if (localStorage.getItem('access_token')){
           return (<Route {...this.props}/>)
       }else{
           return (<Redirect to='/login'/>)
       }
   }
}


export default connect()(PrivateRoute)
